import React from 'react';

const Features: React.FC = () => {
  const features = [
    {
      icon: 'ri-robot-line',
      title: 'AI Agent Composer',
      description: 'Compose & orchestrate AI Agents across your entire IT stack with no development required.',
      image: 'https://public.readdy.ai/ai/img_res/4226fe909ed970bb7dd67bd3c83dd592.jpg'
    },
    {
      icon: 'ri-links-line',
      title: 'Hyperflow Integration',
      description: 'Seamlessly connect and automate workflows across different systems with minimal effort.',
      image: 'https://readdy.ai/api/search-image?query=interconnected%20network%20nodes%20and%20data%20flow%20visualization%2C%20digital%20integration%20concept%2C%20clean%20modern%20design%20with%20blue%20accents&width=400&height=300&seq=integration&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Enterprise Security',
      description: 'ISO/IEC 27001:2022 certified platform ensuring the highest security standards.',
      image: 'https://readdy.ai/api/search-image?query=cybersecurity%20shield%20protection%20with%20digital%20lock%20and%20encrypted%20data%20streams%2C%20professional%20security%20concept%2C%20blue%20and%20silver%20colors&width=400&height=300&seq=security&orientation=landscape'
    },
    {
      icon: 'ri-speed-line',
      title: 'Zero-Touch Automation',
      description: 'Automate service delivery with intelligent agents that handle incidents and requests automatically.',
      image: 'https://readdy.ai/api/search-image?query=automated%20workflow%20dashboard%20with%20real-time%20monitoring%20and%20control%20panels%2C%20modern%20UI%20design%2C%20blue%20and%20white%20interface&width=400&height=300&seq=automation&orientation=landscape'
    },
    {
      icon: 'ri-team-line',
      title: 'Multi-Tenant Support',
      description: 'Built for MSPs with advanced user access controls and multi-tenant architecture.',
      image: 'https://readdy.ai/api/search-image?query=multiple%20user%20groups%20and%20organizations%20connected%20in%20a%20network%20diagram%2C%20collaborative%20workspace%20concept%2C%20modern%20flat%20design&width=400&height=300&seq=multitenant&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Scalable Platform',
      description: 'From community edition to enterprise, scale your automation needs as you grow.',
      image: 'https://readdy.ai/api/search-image?query=growth%20chart%20and%20scaling%20infrastructure%20visualization%2C%20business%20expansion%20concept%2C%20upward%20trending%20graphs%20in%20blue%20tones&width=400&height=300&seq=scalable&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Connect Apps. Build Agents. Automate Everything!
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Autom Mate is the automation and integration platform you have been looking for! Scale your workflows seamlessly across different systems with minimal effort and predictable cost.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url(${feature.image})` }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;